import {TaskTypeActionRequired} from "../task-type/task-type"

export default class OptionsAccessManager {

    static allowNoActionRequiredUserOption(taskTypeId:ID) {
        const actionRequired = gd.session.taskTypes.get(taskTypeId)?.settings?.actionRequired
        return !actionRequired || actionRequired === TaskTypeActionRequired.ALLOWED
    }
}